import {Skeleton} from '@kaman/uikit';

const StoreDetailSkeleton = () => {
    return (
        <main aria-busy="true" aria-label="در حال بارگذاری جزئیات فروشگاه">
            <div className="mx-4 mt-8 rounded-2xl border border-gray-200 bg-white p-4">
                <div className="flex items-center gap-3">
                    <Skeleton variant="circular" width={64} height={64} />
                    <div className="flex flex-1 flex-col gap-2">
                        <Skeleton width="45%" height={20} />
                        <Skeleton width="30%" height={16} />
                    </div>
                </div>
                <div className="mt-4 flex gap-2">
                    <Skeleton width="50%" height={40} />
                    <Skeleton width="50%" height={40} />
                </div>
            </div>

            <div className="flex flex-col gap-3 border-b border-gray-200 px-5 py-5">
                <div className="flex justify-between gap-4">
                    <Skeleton width="35%" height={24} />
                    <Skeleton width={72} height={28} />
                </div>
                <Skeleton width="100%" height={16} />
                <Skeleton width="100%" height={16} />
                <Skeleton width="75%" height={16} />
            </div>

            <div className="flex flex-col gap-3 border-b border-gray-200 px-5 py-5">
                <Skeleton width="35%" height={24} />
                <Skeleton width="100%" height={18} />
                <Skeleton width="70%" height={18} />
            </div>

            <div className="flex flex-col gap-3 border-b border-gray-200 px-5 py-5">
                <Skeleton width="45%" height={24} />
                <div className="flex gap-2">
                    <Skeleton width={80} height={32} />
                    <Skeleton width={80} height={32} />
                </div>
            </div>

            <div className="flex flex-col gap-3 px-5 py-5">
                <Skeleton width="25%" height={24} />
                <div className="grid grid-cols-2 gap-3">
                    <Skeleton width="100%" height={180} />
                    <Skeleton width="100%" height={180} />
                </div>
            </div>
        </main>
    );
};

export default StoreDetailSkeleton;
